import { useState, useEffect } from 'react';
import { ref, onValue, set } from 'firebase/database';
import { db } from '../firebase';
import { useAuthContext } from '../contexts/AuthContext';
import { ownerQualifiesForHistory } from '../utils/historyAccess';

/**
 * 閲覧者がこのイベントの応募者履歴を見られるか（現在のライセンス状態で判定）。
 * - superadmin: 常に可
 * - owner 本人: 自分のライセンスが pro/trial かつ有効なら可
 * - staff: イベント側のフラグ events/{eventId}/history_enabled を見る
 *   （staff は他人の users ノードを読めないため、owner 資格をイベントに転記する）
 *
 * owner/superadmin がイベントを開いた時に history_enabled を最新化する。
 */
export const useHistoryAccess = (eventId, event) => {
  const { user, userProfile } = useAuthContext();
  const role    = userProfile?.role?.trim()?.toLowerCase();
  const uid     = user?.uid;
  const ownerId = event?.owner_id;

  const isSuper     = role === 'superadmin';
  const isSelfOwner = !!uid && ownerId === uid;
  const selfQualifies = isSelfOwner && ownerQualifiesForHistory(userProfile);

  const [staffFlag, setStaffFlag] = useState(false);

  // owner 本人が開いた時、staff 向けに資格フラグを転記
  useEffect(() => {
    if (!eventId || !isSelfOwner) return;
    set(ref(db, `events/${eventId}/history_enabled`), !!selfQualifies).catch(() => {});
  }, [eventId, isSelfOwner, selfQualifies]);

  // staff（その他）はイベント側フラグを購読
  useEffect(() => {
    if (!eventId || isSuper || isSelfOwner) { setStaffFlag(false); return; }
    const r = ref(db, `events/${eventId}/history_enabled`);
    const unsub = onValue(r, (s) => setStaffFlag(s.val() === true), () => setStaffFlag(false));
    return () => unsub();
  }, [eventId, isSuper, isSelfOwner]);

  if (isSuper)     return true;
  if (isSelfOwner) return !!selfQualifies;
  return staffFlag;
};
